export const formatCallingCode = (code: string) => `+${code}`
